/*
 *
 * GeoSearch reducer
 *
 */

import { fromJS } from 'immutable';
import {
  GEO_SEARCH,
  GEO_SEARCH_CLEAR,
  GEO_SEARCH_FOUND,
  GEO_SELECT,
} from './constants';

export const initialState = fromJS({ searching: false });

function geoSearchReducer(state = initialState, action) {
  switch (action.type) {
    case GEO_SEARCH:
      return state
        .delete('results')
        .delete('selected')
        .merge({ searching: true });
    case GEO_SEARCH_CLEAR:
      return state.delete('results').delete('selected');
    case GEO_SELECT:
      return state.merge({ selected: action.item });
    case GEO_SEARCH_FOUND:
      return state.merge({
        searching: false,
        results: action.results,
      });
    default:
      return state;
  }
}

export default geoSearchReducer;
